export const DividerPartials = {
	DividerPartials: {
		width: {
			regular: 22.4,
		},
	},
};

export default DividerPartials;
